// Emotion words cloud generator
export function initEmotionCloud() {
  const emotionWords = [
    "HAPPY",
    "SAD",
    "ANGRY",
    "EXCITED",
    "CALM",
    "ANXIOUS",
    "JOYFUL",
    "MELANCHOLY",
    "FURIOUS",
    "THRILLED",
    "PEACEFUL",
    "NERVOUS",
    "CONTENT",
    "DEPRESSED",
    "RAGE",
    "DELIGHTED",
    "SERENE",
    "WORRIED",
    "CHEERFUL",
    "GLOOMY",
    "IRRITATED",
    "ECSTATIC",
    "TRANQUIL",
    "STRESSED",
    "ELATED",
    "MISERABLE",
    "IRATE",
    "OVERJOYED",
    "RELAXED",
    "UNEASY",
    "BLISSFUL",
    "HEARTBROKEN",
    "ENRAGED",
    "EXUBERANT",
    "MELLOW",
    "TENSE",
    "UPBEAT",
    "SORROWFUL",
    "LIVID",
    "GLEEFUL",
    "COMPOSED",
    "APPREHENSIVE",
    "RADIANT",
    "DESPONDENT",
    "WRATHFUL",
    "JUBILANT",
    "UNRUFFLED",
    "AFRAID",
    "BUOYANT",
    "DESOLATE",
    "SEETHING",
    "EUPHORIC",
    "EVEN-TEMPERED",
    "PANICKED",
    "SPIRITED",
    "FORLORN",
    "INCENSED",
    "RAPTUROUS",
    "BALANCED",
    "FRIGHTENED",

    // 更细微的情绪形容词
    "WISTFUL",
    "BITTERSWEET",
    "NOSTALGIC",
    "WHIMSICAL",
    "PENSIVE",
    "MELANCHOLIC",
    "PLAINTIVE",
    "POIGNANT",
    "WONDROUS",
    "BEWITCHED",
    "ENCHANTED",
    "CAPTIVATED",
    "INFATUATED",
    "ENAMORED",
    "SMITTEN",
    "BESOTTED",
    "LOVESTRUCK",
    "WRETCHED",
    "ANGUISHED",
    "TORMENTED",
    "DISTRAUGHT",
    "BEREFT",
    "DESOLATE",
    "FORLORN",
    "DOLEFUL",
    "DISCONSOLATE",
    "INCONSOLABLE",
    "WOEFUL",
    "LAMENTABLE",
    "MOURNFUL",
    "DEJECTED",
    "DOWNCAST",
    "CRESTFALLEN",
    "DISPIRITED",
    "DISHEARTENED",
    "DESPAIRING",
    "HOPELESS",
    "GLOOMY",
    "PESSIMISTIC",
    "SULLEN",
    "MOROSE",
    "SULKY",
    "RESENTFUL",
    "BITTER",
    "ACRIMONIOUS",
    "INDIGNANT",
    "OFFENDED",
    "SLIGHTED",
    "AFFRONTED",
    "INSULTED",
    "MORTIFIED",
    "HUMILIATED",
    "ASHAMED",
    "EMBARRASSED",
    "ABASHED",
    "FLUSTERED",
    "DISCONCERTED",
    "PERPLEXED",
    "BEFUDDLED",
    "BEWILDERED",
    "CONFUSED",
    "DAZED",
    "DISORIENTED",
    "MUDDLED",
    "ADDLED",

    // 积极情绪的细微差别
    "OPTIMISTIC",
    "HOPEFUL",
    "ENCOURAGED",
    "INSPIRED",
    "MOTIVATED",
    "ENERGIZED",
    "INVIGORATED",
    "EXHILARATED",
    "EBULLIENT",
    "BUOYANT",
    "LIGHTHEARTED",
    "FRIVOLOUS",
    "PLAYFUL",
    "JOVIAL",
    "CONVIVIAL",
    "AMIABLE",
    "GENIAL",
    "AFFABLE",
    "CORDIAL",
    "WARM",
    "TENDER",
    "LOVING",
    "AFFECTIONATE",
    "DEVOTED",
    "ADORING",
    "ENTHRALLED",
    "FASCINATED",
    "INTRIGUED",
    "CURIOUS",
    "INQUISITIVE",
    "CONTEMPLATIVE",
    "REFLECTIVE",
    "MEDITATIVE",
    "TRANQUIL",
    "SERENE",
    "PLACID",
    "QUIESCENT",
    "UNDISTURBED",
    "UNTROUBLED",
    "UNFAZED",
    "STEADFAST",
    "RESOLUTE",
    "DETERMINED",
    "UNWAVERING",
    "STALWART",
    "CONFIDENT",
    "ASSURED",
    "SELF-ASSURED",
    "COCKSURE",
    "ARROGANT",

    // 微妙的负面情绪
    "DISCONTENT",
    "DISSATISFIED",
    "DISPLEASED",
    "DISGRUNTLED",
    "CHAFED",
    "VEXED",
    "ANNOYED",
    "EXASPERATED",
    "AGGRAVATED",
    "PROVOKED",
    "PIQUED",
    "OFFENDED",
    "MIFFED",
    "IRKED",
    "NETTLED",
    "RUFFLED",
    "RILED",
    "RANKLED",
    "GALLED",
    "CHAFED",
    "DAUNTED",
    "INTIMIDATED",
    "COWED",
    "BULLIED",
    "BROWBEATEN",
    "DEFEATED",
    "VANQUISHED",
    "CRUSHED",
    "BROKEN",
    "SHATTERED",
    "FRAGILE",
    "VULNERABLE",
    "EXPOSED",
    "UNPROTECTED",
    "DEFENSELESS",
    "HELPLESS",
    "POWERLESS",
    "IMPOTENT",
    "INEFFECTUAL",
    "USELESS",
    "WORTHLESS",
    "INSIGNIFICANT",
    "UNIMPORTANT",
    "OVERLOOKED",
    "NEGLECTED",
    "FORGOTTEN",
    "ABANDONED",
    "FORSAKEN",
    "CAST-OFF",
    "DISCARDED",
  ];

  const emotionCloud = document.querySelector(".emotion-cloud");
  if (!emotionCloud) return;

  // Clear existing words
  emotionCloud.innerHTML = "";

  // Shuffle array for random distribution
  const shuffled = [...emotionWords].sort(() => Math.random() - 0.5);

  // Create word elements
  shuffled.forEach((word) => {
    const wordSpan = document.createElement("span");
    wordSpan.className = "emotion-word";
    wordSpan.textContent = word;

    emotionCloud.appendChild(wordSpan);
  });
}
